// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { commonConfig as commonEnv } from './environment.common';

export const environment = {
  ...commonEnv,
  production: false,

  // basepath_content_viewer: 'https://uat.hengansl.com.hk:2096/api',
  // basepath_user_account_management: 'https://uat.hengansl.com.hk:2096/api',
  // basepath_transaction: 'https://uat.hengansl.com.hk:2096/api',

  // basepath_content_viewer: 'http://localhost:63188/api',
  // basepath_user_account_management: 'http://localhost:63187/api',
  // basepath_transaction: 'http://localhost:63186/api',

  basepath_content_viewer: 'https://www.hengansl.com.hk/api',
  basepath_user_account_management: 'https://www.hengansl.com.hk/api',
  basepath_transaction: 'https://www.hengansl.com.hk/api',

  // investplatform_url: 'https://uat-hengan.aqumon.com/#/',
  esqs_url: 'https://www.hengansl.com.hk/eSQS/',
  pos_url: 'https://www.hengansl.com.hk/pos/',
  investplatform_url: 'https://sangria.aqumon.com/#/',

  googleTag: 'UA-173488825-1'
};

// export const environment = {
//   production: false,
//   basepath_content_viewer: 'https://218.253.250.211:2052/api',
//   basepath_user_account_management: 'https://218.253.250.211:2052/api',
//   basepath_transaction: 'https://218.253.250.211:2052/api',
//   version: 'BS_1.0.10'
// };

// https://uat.hengansl.com.hk:2052/api
// https://slhkwebapi-uat1:2052/api
// https://218.253.250.211:2052/api
// morningStar_screener_url: 'https://hkuat01.morningstar.com/quikr/standardlife/ec-screener_default.html?languageId=',
//  morningStar_fund_comparison_url: 'https://hkuat01.morningstar.com/quikr/standardlife/ec-InvestmentCompare_default.html?languageId=',

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
